/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './errorSummary.module.css';

const ErrorSummary = ({
  title, errors, onJump
}) => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
    ref.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, [errors?.length]);

  if (!errors?.length) return null;

  const titleId = 'error_summary_title';

  return (
    <section
      ref={ref}
      tabIndex={-1}
      aria-labelledby={titleId}
      className={styles.container}
    >
      <span className={`icon--warning ${styles.icon}`} aria-hidden />
      <div className={styles.content}>
        <h2 className={styles.title} id={titleId}>{title}</h2>
        <ul className={styles.errorList}>
          {errors.map((error) => (
            <li key={error.id} className={styles.item}>
              <a
                href=""
                onClick={(event) => {
                  event.preventDefault();
                  onJump(error);
                }}
              >
                {error.linkText}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

ErrorSummary.propTypes = {
  title: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    linkText: PropTypes.string.isRequired
  })).isRequired,
  onJump: PropTypes.func.isRequired
};

export default ErrorSummary;
